import {
  Dispositions,
  Markdown,
  MarkdownOptions,
  PendingReasonsRaw,
  ReasonInputType,
} from '@ozark/common';
import {createDisputeReason} from '../createDisputeReason';
import {DisputeReason} from '../index';

export const pending = {
  [Dispositions.uwPending]: PendingReasonsRaw.map(reason => {
    const {name, description, type, params, paramsDetails} = reason;

    let paramsDescriptions: Record<string, string> = {};

    /* Pending Reasons with Select Input Type may have different details for each param */
    if (type === ReasonInputType.Select && paramsDetails) {
      paramsDescriptions = Object.keys(paramsDetails).reduce((acc: Record<string, string>, key) => {
        acc[key] =
          Markdown?.render(paramsDetails[key as keyof typeof paramsDetails]?.description ?? '', {
            linkify: true,
            html: true,
          } as MarkdownOptions) || '';
        return acc;
      }, {});
    }

    return createDisputeReason({
      name: name,
      description:
        Markdown?.render(description, {linkify: true, html: true} as MarkdownOptions) || '',
      type: type,
      params,
      paramsDescriptions,
    });
  }) as DisputeReason[],
} as {[key in Dispositions]?: DisputeReason[]};
